// ──────────────────────────────────────────────
// Constantes centralizadas — Estef's Cakes
// ──────────────────────────────────────────────

/** URL base de Sheetbest (Google Sheets como API) */
export const SHEETBEST_URL =
  "https://api.sheetbest.com/sheets/fe0575d5-34a0-49e6-882e-3931528c9130";

/** Número de WhatsApp (formato internacional sin +) */
export const WHATSAPP_NUMBER = "584165811132";

/** URL base de los Netlify Functions (producción) */
export const PROD_API_BASE = "https://estefscakes.com/.netlify/functions";

// En entorno local (localhost), apuntar a las funciones de Netlify en producción para leer y escribir en MongoDB Atlas en vivo
const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.startsWith("192.168."));

export const API_BASE = isLocalhost ? PROD_API_BASE : "/.netlify/functions";

/** Endpoints de Netlify Functions (en dev apunta a PROD_API_BASE y en prod a relative) */
export const API = {
  GET_CAKES: `${API_BASE}/get-cakes`,
  GET_PUBLIC_CAKES: `${API_BASE}/get-public-cakes`,
  ADD_CAKE: `${API_BASE}/add-cake`,
  UPDATE_CAKE: `${API_BASE}/update-cake`,
  DELETE_CAKE: `${API_BASE}/delete-cake`,
  IMAGEKIT_AUTH: `${API_BASE}/imagekit-auth`,
  ADMIN_LOGIN: `${API_BASE}/admin-login`,
  CLARITY_INSIGHTS: `${API_BASE}/clarity-insights`,
} as const;

/** Dominio del sitio */
export const SITE_DOMAIN = "estefscakes.com";

/** Instagram handle */
export const INSTAGRAM_HANDLE = "estefscakes";
export const INSTAGRAM_URL = `https://instagram.com/${INSTAGRAM_HANDLE}`;

/** Dominio del panel admin (para detección en App.tsx) */
export const ADMIN_SUBDOMAIN = "admin.estefscakes.com";

/** ImageKit upload endpoint */
export const IMAGEKIT_UPLOAD_URL = "https://upload.imagekit.io/api/v1/files/upload";

/** ImageKit public key (seguro para el cliente; usado en subidas) */
export const IMAGEKIT_PUBLIC_KEY = "public_hK04ZJmsP1Z2qKms4Ww/F/q1WzQ=";
